import {request} from "./request";

// 设置自定义数据 
export function set_custom_action(params) {
    return request({
        url: '/hkt/storeconfig/set_custom_action',
        params,
    })
}



// 获取企业文章列表
export function getArticleList(pagesize, page, class_id, title, search_time) {
    return request({
        url: '/hkt/article/get_article_list',
        params: {
            pagesize,
            page,
            class_id,
            title,
            search_time
        }
    })
}
// 获取企业文章列表2
// pagesize, page, class_id, title, search_time
export function getArticleLis2(params) {
    return request({
        url: '/hkt/article/get_article_list',
        params,
    })
}
// 修改企业文章
export function editArticle(data) {
    return request({
        url: '/hkt/article/edit_article',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: data
    })
}

// 获取公共文章列表
export function getArticlePublicList(pagesize, page, title, class_id, search_time) {
    return request({
        url: '/hkt/articlepublic/get_article_public_list',
        params: {
            pagesize,
            page,
            title,
            class_id,
            search_time
        }
    })
}
// 获取公共文章列表
// pagesize, page, title, class_id, search_time
export function getArticlePublic2(params) {
    return request({
        url: '/hkt/articlepublic/get_article_public_list',
        params,
    })
}
// 创建文章
export function addArticle(data) {
    return request({
        url: '/hkt/article/add_article',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: data
    })
}
// 删除文章
export function delArticle(article_id) {
    return request({
        url: '/hkt/article/del_article',
        params: {
            article_id
        }
    })
}


// 获取类别列表
export function getArticleClassList(pagesize, page) {
    return request({
        url: '/hkt/articleclass/get_article_class_list',
        params: {
            pagesize,
            page
        }
    })
}
// 获取全部类别列表
export function getArticleClassAllList() {
    return request({
        url: '/hkt/articleclass/get_article_class_list',
    })
}
// 添加文章类别
export function addArticleClass(name, is_show) {
    return request({
        url: '/hkt/articleclass/add_article_class',
        params: {
            name,
            is_show
        }
    })
}
// 修改文章类别
export function edit_article_class(class_id, name, is_show) {
    return request({
        url: '/hkt/articleclass/edit_article_class',
        params: {
            class_id,
            name,
            is_show
        }
    })
}
// 删除文章类别
export function del_article_class(class_id) {
    return request({
        url: '/hkt/articleclass/del_article_class',
        params: {
            class_id,
        }
    })
}

// 二维码
export function getArticleCode(article_id) {
    return request({
        url: '/hkt/article/get_article_code',
        params: {
            article_id,
        }
    })
}

export function operateArticle(article_id, operate_type) {
    return request({
        url: '/hkt/article/operate_article',
        params: {
            article_id,
            operate_type
        }
    })
}

export function getArticleRecord(pagesize, page, title, search_time) {
    return request({
        url: '/hkt/article/get_article_record',
        params: {
            pagesize,
            page,
            title,
            search_time
        }
    })
}

export function getArticleReco2(params) {
    return request({
        url: '/hkt/article/get_article_record',
        params,
    })
}
// 删除我的分享
export function delArticleRecord(article_id) {
    return request({
        url: '/hkt/article/del_article_record',
        params: {
            article_id,
        }
    })
}


// 文章图片显示设置
export function setArticleImageType(article_image_type) {
    return request({
        url: '/hkt/storeconfig/set_article_image_type',
        params: {
            article_image_type,
        }
    })
}
// 获取项目配置
export function getStoreConfig() {
    return request({
        url: '/hkt/storeconfig/get_store_config',
        params: {

        }
    })
}

// 获客意向设置
export function setIntentJudge(visit_count, intent_type, visit_time, type) {
    return request({
        url: '/hkt/storeconfig/set_intent_judge',
        params: {
            visit_count,
            intent_type,
            visit_time,
            type
        }
    })
}
